export default __webpack_public_path__ + "static/media/how-to-purchase.1cc3b1cd.svg";